import { Fragment, useState, useEffect, useRef } from 'react'
import { useDispatch, useSelector } from "react-redux"
import { Row, Col, Nav, NavItem, NavLink, TabContent, TabPane, Table, Label, Input, Button, Form, ModalBody, ModalFooter, FormFeedback, Spinner, Accordion, AccordionBody, AccordionHeader, AccordionItem } from 'reactstrap'
import ComponentSpinner from '../../../components/spinner/Loading-spinner'
import { getAllUsers, getWoLoading, GetUserRoles, GetUserDetailsbyEmail, CreateUser, SaveUserRoles, GetAgentDetails } from '../../redux/store'
import { ChevronRight, ChevronDown, ChevronUp, Plus, RefreshCcw, Trash } from 'react-feather'
import Select, { components } from 'react-select'
import { selectThemeColors } from '@utils'
import { isUserLoggedIn, isObjEmpty } from '../../../utility/Utils'
import Sidebar from '../../Components/SideBar'
import * as yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'
import { useForm, Controller } from 'react-hook-form'
import toast from 'react-hot-toast'
import { DefaultConfig } from '../../../settings/config'
import ToastMessage from '../../../components/toast-messages'
import classnames from 'classnames'
import CustomValueContainer from "../../Components/Select"
import CustomValueContainer1 from "../../Components/ToolTipSelect"
import MultiSelect from '../MultiSelectFRP'
const statusData = [
  { value: 1, label: 'System Admin' },
  { value: 2, label: 'User Reader' },
  { value: 3, label: 'User Writer' },
  { value: 4, label: 'Company Reader' },
  { value: 5, label: 'Company Writer' },
  { value: 6, label: 'Vessel Reader' },
  { value: 7, label: 'Vessel Writer' }

]

const roles = [
  { id: 1, name: "System Admin", value: "System Admin", label: "System Admin" },
  { id: 2, name: "Customer Reader", value: "Customer Reader", label: "Customer Reader" },
  { id: 3, name: "Customer Writer", value: "Customer Writer", label: "Customer Writer" },
  { id: 4, name: "Employee Reader", value: "Employee Reader", label: "Employee Reader" },
  { id: 5, name: "Employee Writer", value: "Employee Writer", label: "Employee Writer" }
]

const menuData = [{ value: 'User', label: 'User' }, { value: 'Company Mapping', label: 'Company Mapping' }, { value: 'Vessel Mapping', label: 'Vessel Mapping' }]

const RoleManagement = ({ editable }) => {

  const stores = useSelector((state) => state.commonreducerSlice)
  const { userRoleData } = useSelector((state) => state.commonreducerSlice)
  const isEmployee = isUserLoggedIn && JSON.parse(isUserLoggedIn()).userRoles
  const [woData, setWoData] = useState([])
  const dispatch = useDispatch()
  const [sortOrder, setSortOrder] = useState("asc")
  const [sortName, setSortName] = useState("Id")
  const [filteredData, setFilteredData] = useState([])
  const [selectedRow, setSelectedRow] = useState(null)
  const [roleLoader, setRoleLoader] = useState(false)
  const [activeR, setActiveR] = useState('1')
  const [active, setActive] = useState('1')
  const [searchCatg, setSearchCatg] = useState('')
  const [roleDisabled, setDisabled] = useState(true)
  const [roleData, setRoleData] = useState([])
  const [catgList, setCatgList] = useState([])
  const [searchText, setSearchText] = useState('')
  const [enterCatgKey, setEnterCatgKey] = useState('')
  const [show, setShow] = useState(false)
  const [accessDisabled, setAcessDisabled] = useState(editable)
  const [usersSpinner, setUsersSpinner] = useState(false)
  const [saveRole, setSaveRole] = useState(null)
  const SourceSystem = DefaultConfig().SourceSystem
  const [selectSelectOptions, setSelectSelectOptions] = useState([])
  const [selectedSourceSystem, setSelectedSourceSystem] = useState(null)
  const [selectedCompany, setSelectedCompany] = useState([])
  const selectStyles = DefaultConfig().selectStyles
  const tableRef = useRef(null)
  const [userMappingData, setUserMappingData] = useState([])
  const [userMappingSpinner, setUserMappingSpinner] = useState(false)
  const [displayData, setDisplayData] = useState([])
  const [openAccordions, setOpenAccordions] = useState([])
  const [agentInput, setAgentInput] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const [addCompanyOption, setAddCompanyOption] = useState(false)
  const [companyData, setCompanyData] = useState([])
  const [agentObj, setAgentObj] = useState(null)
  const [userSpinnerData, setUserSpinnerData] = useState(false)


  function domain(row) {
    return row?.split("@")[1] === "liscr.com"
  }

  const handleInputChange = (inputValue, action) => {
    if (action?.action !== "input-blur" && action?.action !== "menu-close") {
      setAgentInput(inputValue)
    }
  }

  useEffect(() => {
    if (agentInput.length > 2) {
      setIsLoading(true)
      const timer = setTimeout(() => {
        const searchOptions = async () => {
          if (agentInput) {
            const responseData = await dispatch(GetAgentDetails(agentInput))
            const companyData = responseData.payload

            if (companyData) {
              const sfCompanys = []
              if (companyData.length > 0) {
                companyData.forEach((item) => {
                  if (item.customerNumber) {
                    sfCompanys.push({ value: item.customerNumber, label: `${item.customerName} ${item.customerNumber !== null ? `(${item.customerNumber})` : ''}`, name: item.customerName, agentId: item.customerNumber, classId: item.customerClassId, address1: item.address1, address2: item.address2, city: item.city, customerClassName: item.customerClassName, country: item.country, state: item.state, customerName: item.customerName })
                  }
                })
              } else {
                setAddCompanyOption(true)
              }
              setCompanyData(sfCompanys)
              setIsLoading(false)
            }
          }
        }
        if (agentInput) {
          setIsLoading(true)
          setAddCompanyOption(false)
          searchOptions()
        } else {
          setIsLoading(false)
          setCompanyData([])
        }
      }, 500)
      return () => clearTimeout(timer)
    } else {
      setIsLoading(false)
      setCompanyData([])
      setAddCompanyOption(false)
    }
  }, [agentInput])

  function accessingData(value) {
    if (value === 1) {
      return roles.splice(0, 1)
    } else if (value === 3) {
      return [roles[1], roles[2]]
    } else if (value === 5) {
      return [roles[1], roles[2], roles[3]]
    }
  }

  useEffect(() => {
    if (selectedRow && tableRef?.current) {
      setTimeout(() => {
        tableRef?.current?.scrollIntoView({ top: 50, behavior: "smooth", block: "nearest" })
      }, 100)
    }
  }, [selectedRow])

  const groupBySourceSystem = (data, flag) => {
    const selectOptions = SourceSystem("options")
    return data.reduce((acc, item) => {
      const { sourceSystemId, agentId, companyId, agentName, roleId } = item

      const selectiveSourceSystem = selectOptions.find((source) => source.id === sourceSystemId)
      const existingGroup = acc.find(group => group.sourceSystemId === sourceSystemId)

      if (existingGroup) {
        existingGroup.details.push({ agentId, companyId, agentName, value: agentId, label: agentName, roleId })
      } else {
        if (selectiveSourceSystem) {
          acc.push({
            sourceSystemId,
            label: selectiveSourceSystem?.label,
            value: selectiveSourceSystem?.value,
            details: [{ agentId, companyId, agentName, value: agentId, label: agentName, existingRemove: !(flag.length === 0), roleId }]
          })
        }
      }

      return acc
    }, [])
  }

  useEffect(() => {
    const userData = JSON.parse(localStorage.getItem('userData'))
    const groupedData = groupBySourceSystem(userData?.userRoles, "")

    if (JSON.parse(isUserLoggedIn()).userRoles[0].roleId === 1 && !domain(selectedRow?.email)) {
      setSelectSelectOptions(SourceSystem("options"))
    } else {
      setSelectSelectOptions(groupedData)
    }
  }, [selectedRow])

  useEffect(() => {
    setCatgList(menuData)
  }, [])

  async function fetchApi(selectedRow) {
    setUserMappingSpinner(true)
    setUserSpinnerData(true)
    const data = await dispatch(GetUserRoles(selectedRow.id))
    setDisplayData(groupBySourceSystem(data?.payload?.data, ""))
    setOpenAccordions(data?.payload?.data.map(() => ""))
    setUserMappingData(data?.payload?.data)

    const role = data?.payload?.data?.[0]?.roleId
    if (role === 1) {
      setDisabled(false)
    } else {
      setDisabled(false)
    }
    setRoleLoader(true)
    setUserMappingSpinner(false)
    setUserSpinnerData(false)
  }

  const handleCatgFilterData = () => {
    const filteredData = menuData.filter((find) => (find.label && String(find.label).toLowerCase().includes(searchCatg.toLowerCase())))
    setCatgList(filteredData)
  }

  const callFunction = (rData) => {
    if (rData.find(find => (find.roleId === 1))) {
      setDisabled(false)
    }
    setRoleData(rData)
  }

  useEffect(() => {
    if (userRoleData.length > 0) {
      callFunction(userRoleData)
    }
  }, [userRoleData])

  const toggleTabRight = tab => {
    if (activeR !== tab) {
      setActiveR(tab)
    }
  }

  const loadingData = (data) => {
    const tempData = JSON.parse(isUserLoggedIn())
    const employeeFlag = tempData?.email.split("@")[1] === "liscr.com"
    const roleId = tempData.userRoles[0].roleId
    const matchFunction = (item) => {
      if (roleId === 1) {
        return true
      }
      if (employeeFlag) {
        return item.email.split("@")[1] === "liscr.com"
      } else {
        return item.email.split("@")[1] !== "liscr.com"
      }
    }

    const mappedData = data.filter(matchFunction) // Correct filter usage
    setWoData(mappedData)
    setFilteredData(mappedData)
  }

  useEffect(() => {
    async function callAllUsers() {
      setUsersSpinner(true)
      const userResponse = await dispatch(getAllUsers({
        pageIndex: 0,
        pageSize: 0,
        sortName,
        sortOrder
      }))


      if (userResponse.payload) {

        loadingData(userResponse?.payload?.data?.length ? userResponse?.payload?.data : [])

        const totalRecords = userResponse?.payload?.data?.length ? userResponse?.payload?.data : []
        if (totalRecords.length > 0) {
          //   setSelectedRow(totalRecords[0])
        }
      } else {
        // setDisplayTableData(false)
      }
      // await dispatch(GetAllRoles()).finally(() => {

      // })
      setUsersSpinner(false)
      setAcessDisabled(editable)
    }

    callAllUsers()

  }, [dispatch, sortName, sortOrder])

  function RefreshDataSystem(data) {
    if (!data) {
      setSaveRole(null)
      setAgentObj(null)
      setSelectedSourceSystem(null)
    } else {
      setSelectedSourceSystem(null)
      setSelectedCompany([])
      setSaveRole(null)

    }
  }

  const handleRowClick = (row) => {
    setSelectedRow(row)
    if (row) {

      const tempData = filteredData.filter((item) => item.id !== row.id)
      setFilteredData([row, ...tempData])
    }
  }

  useEffect(() => {
    if (selectedRow) {
      setDisabled(false)
      setRoleLoader(false)
      setRoleData([])

      fetchApi(selectedRow)
    }
  }, [selectedRow])


  const handleCatgBlur = () => {
    if (searchCatg.length > 0 && enterCatgKey !== 'Enter') {
      handleCatgFilterData('')
    }
  }

  const handleKeyCatgDown = (event) => {
    if (event.key === 'Enter') {
      setEnterCatgKey('Enter')
      if (searchCatg.length > 0) {
        handleCatgFilterData('')
      }
    }
  }

  const handleSearchChange = (e) => {
    const value = e.target.value
    setSearchText(value)

    if (value) {
      const filtered = woData.filter(user => {
        const fullName = `${user.firstName || ''} ${user.lastName || ''}`.toLowerCase()
        const email = user.email.toLowerCase()
        return fullName.includes(value.toLowerCase()) || email.includes(value.toLowerCase())
      })
      if (selectedRow) {
        const tempData = filtered.filter((item) => item.id !== selectedRow?.id)
        setFilteredData([selectedRow, ...tempData])
      } else {
        setFilteredData(filtered)
      }

    } else {
      if (selectedRow) {
        const tempData = [...woData].filter((item) => item.id !== selectedRow?.id)
        setFilteredData([selectedRow, ...tempData])
      } else {
        setFilteredData(woData)
      }
    }
  }

  const handleInviteUserClick = () => {
    setShow(true)
  }

  const ValidSchema = yup.object().shape({
    [`newFirstName`]: yup.string().nullable().required("First Name is a required field"),

    [`newLastName`]: yup.string().nullable().required("Last Name is a required field"),
    [`newEmail`]: yup.string().trim().nullable().required("Email is a required field").email("Email is invalid").matches(/^[\w.%+-]+@liscr\.com$/, "Only liscr.com email addresses are allowed")
  })


  const { trigger, handleSubmit, control, reset, setValue, formState: { errors } } = useForm({ mode: 'onChange', resolver: yupResolver(ValidSchema) })


  const [newFirstName, setNewFirstName] = useState("")
  const [newLastName, setNewLastName] = useState("")
  const [newEmail, setNewEmail] = useState("")
  const [disableSpinner, setDisableSpinner] = useState(false)
  const [disabling, setDisabling] = useState(false)
  const [spinnerStatus, setSpinnerStatus] = useState(false)
  const [isEmailProcessed, setIsEmailProcessed] = useState(false)
  const [isSaveEnabled, setSaveEnabled] = useState(false)


  const handleReset = () => {
    reset({
      newFirstName: null,
      newLastName: null,
      newEmail: null
    })
    setNewEmail("")
    setValue("newEmail", "")
    setNewFirstName("")
    setValue("newFirstName", "")
    setValue("newLastName", "")
    setNewLastName("")
    setDisabling(false)

    setDisableSpinner(false)
    setIsEmailProcessed(false)
    setDisabling(false)
  }

  const toggleSidebar = () => {
    handleReset()
    setShow(!show)
  }

  async function fetchCall() {
    if (!errors.newEmail && newEmail) {
      setDisableSpinner(true)
      const response = await dispatch(GetUserDetailsbyEmail({ Email: newEmail }))
      setDisableSpinner(false)
      if (!response?.payload?.data) {
        setDisabling(false)
      } else {
        setIsEmailProcessed(true)
        setDisabling(true)
        setValue("newFirstName", response?.payload?.data.firstName)
        setNewFirstName(response?.payload?.data.firstName)
        setValue("newLastName", response?.payload?.data.lastName)
        setNewLastName(response?.payload?.data.lastName)
      }
    }
  }

  const onSubmit = async () => {
    trigger()
    if (isObjEmpty(errors)) {
      setSpinnerStatus(true)
      const obj = { firstName: newFirstName, lastName: newLastName, email: newEmail }
      await dispatch(CreateUser(obj))
      setSpinnerStatus(false)
      setShow(!show)
      handleReset()
    }
  }

  const saveUserRoles = async () => {

    const arrayOfObjects = roleData
      .filter(obj => obj.roleId !== 0)
      .map(obj => ({
        userId: selectedRow?.id,
        userRoleId: obj.roleId
      }))

    setDisabled(false)
    setRoleLoader(false)

    const responseData = await dispatch(SaveUserRoles({ data: arrayOfObjects, userId: selectedRow?.id }))

    const respData = responseData.payload
    if (respData?.data) {
      toast(t => (<ToastMessage t={t} message={"Role updated successfully"} status={"success"} />))
      fetchApi(selectedRow)
    } else {
      setRoleLoader(true)
    }
    callFunction(arrayOfObjects)
  }

  const toggleTab = tab => {
    if (active !== tab) {
      setActive(tab)
    }
  }

  const toggleAccordion = (index) => {
    if (openAccordions.length > 0) {
      const newOpenAccordions = [...openAccordions]
      newOpenAccordions[index] = newOpenAccordions[index] ? "" : index.toString()
      setOpenAccordions(newOpenAccordions)
    }
  }

  const NoOptionsMessage = (props) => {
    return (
      <components.NoOptionsMessage {...props}>
        {addCompanyOption ? (
          <Fragment>
            No Options
          </Fragment>
        ) : (
          <div>Enter min 3 characters.</div>
        )}
      </components.NoOptionsMessage>
    )
  }

  const handleRemove = (index, idx) => {
    setDisplayData((prevData) => prevData.map((item, i) => {
      if (i === index) {
        return { ...item, details: item.details.filter((_, j) => j !== idx) }
      }
      return item
    }).filter((item) => item.details.length > 0)
    )
  }

  const [validErrors, setValidErrors] = useState({
    selectedSourceSystem: "",
    selectedCompany: "",
    saveRole: ""
  })

  const validateForm = () => {
    const newValidErrors = {
      selectedSourceSystem: "",
      selectedCompany: "",
      saveRole: ""
    }

    let isValid = true

    if (!selectedSourceSystem) {
      newValidErrors.selectedSourceSystem = "Source System is required"
      isValid = false
    }
    //  else if (displayData.some(item => item.sourceSystemId === selectedSourceSystem.sourceSystemId)) {
    //   newValidErrors.selectedSourceSystem = "This source system already exists"
    //   isValid = false
    // }

    if (selectedCompany.length === 0) {
      newValidErrors.selectedCompany = "At least one company must be selected"
      isValid = false
    }

    if (!saveRole) {
      newValidErrors.saveRole = "Role is required"
      isValid = false
    }

    setValidErrors(newValidErrors)
    return isValid
  }

  const resetForm = () => {
    setSelectedSourceSystem(null)
    setSelectedCompany([])
    setSaveRole(null)
    setValidErrors({
      selectedSourceSystem: "",
      selectedCompany: "",
      saveRole: ""
    })
  }

  const handleAddEntry = () => {

    if (!validateForm()) return
    if (selectedSourceSystem && selectedCompany.length && saveRole) {
      let tempData = [...displayData]
      if (true) {
        const data = tempData.find((item) => item.sourceSystemId === (selectedSourceSystem?.sourceSystemId || selectedSourceSystem?.id))
        const details = selectedCompany.map((entry) => {
          return { agentId: entry?.agentId, agentName: entry.agentName, roleId: entry.roleId, existingRemove: true, companyId: entry.companyId }
        })
        if (data) {
          const Index = tempData.findIndex((item) => item.sourceSystemId === selectedSourceSystem.sourceSystemId)
          if (Index !== -1) {
            const bufferData = [
              ...tempData.slice(0, Index),
              {
                ...tempData[Index],
                details: [...tempData[Index].details, ...details]
              },
              ...tempData.slice(Index + 1)
            ]
            setDisplayData(bufferData)
          }

        } else {
          const objData = { value: selectedSourceSystem?.value, label: selectedSourceSystem?.value, sourceSystemId: selectedSourceSystem.sourceSystemId, details }
          tempData = [...tempData, objData]

          setDisplayData(tempData)
        }
        setOpenAccordions(tempData.map(() => ""))
        RefreshDataSystem("data")
      }
    }
  }
  const hasRolesToSave = displayData?.flatMap(item => item?.details?.filter(entry => entry?.existingRemove))?.length > 0
  const handleSaveRoles = async () => {

    setUserSpinnerData(true)
    try {
      const transformedData = displayData?.flatMap(item => item?.details?.filter(entry => entry?.existingRemove)?.map(detail => ({
        UserRoleId: detail.roleId,
        CompanyId: detail.companyId,
        SourceSystemId: item.sourceSystemId,
        CreatedBy: JSON.parse(isUserLoggedIn())?.userRoles[0]?.userId,
        LastModifiedBy: JSON.parse(isUserLoggedIn())?.userRoles[0]?.userId
      }))
      ) ?? []

      const responseData = await dispatch(
        SaveUserRoles({
          data: transformedData,
          userId: selectedRow?.id
        })
      )

      if (responseData.payload.data) {
        fetchApi(selectedRow)
      }
    } finally {
      setUserSpinnerData(false)
    }
  }

  const [validError2, setValidError2] = useState({
    agentObj: '',
    selectedSourceSystem: '',
    saveRole: '',
    general: ''
  })

  // Custom validation functions
  const validateAgentSelection = () => {
    if (!agentObj) {
      setValidError2(prev => ({ ...prev, agentObj: 'Agent selection is required' }))
      return false
    }
    setValidError2(prev => ({ ...prev, agentObj: '' }))
    return true
  }

  const validateSourceSystem = () => {
    if (!selectedSourceSystem) {
      setValidError2(prev => ({ ...prev, selectedSourceSystem: 'Source system is required' }))
      return false
    }
    setValidError2(prev => ({ ...prev, selectedSourceSystem: '' }))
    return true
  }

  const validateRole = () => {
    if (!saveRole) {
      setValidError2(prev => ({ ...prev, saveRole: 'Role selection is required' }))
      return false
    }
    setValidError2(prev => ({ ...prev, saveRole: '' }))
    return true
  }

  const validateAll = () => {
    const isAgentValid = validateAgentSelection()
    const isSourceValid = validateSourceSystem()
    const isRoleValid = validateRole()
    return isAgentValid && isSourceValid && isRoleValid
  }

  const handleAddEntry2 = () => {

    if (!validateAll()) return

    try {

      let tempData = [...displayData]
      const existingData = tempData.findIndex((item) => item.sourceSystemId === selectedSourceSystem?.id)
      if (existingData !== -1) {
        let bufferEntries = tempData[existingData]?.details
        bufferEntries = [
          ...bufferEntries, {
            agentId: agentObj?.value,
            agentName: agentObj?.label,
            name: agentObj?.name,
            classId: agentObj?.classId,
            roleId: saveRole?.id,
            companyId: agentObj?.companyId,
            existingRemove: true
          }
        ]
        const DummyData = tempData[existingData]
        DummyData.details = [...bufferEntries]
        tempData[existingData] = DummyData

        setDisplayData(tempData)
        setOpenAccordions(tempData.map(() => ""))
        RefreshDataSystem()
        setValidError2(prev => ({ ...prev, general: '' }))

      } else {
        const details = [
          {
            agentId: agentObj?.value,
            agentName: agentObj?.label,
            name: agentObj?.name,
            classId: agentObj?.classId,
            roleId: saveRole?.id,
            companyId: agentObj?.companyId,
            existingRemove: true
          }
        ]

        {
          // Add new entry
          const objData = {
            value: selectedSourceSystem?.value,
            label: selectedSourceSystem?.value,
            sourceSystemId: selectedSourceSystem.sourceSystemId || selectedSourceSystem.id,
            details
          }
          tempData = [...tempData, objData]
        }

        setDisplayData(tempData)
        setOpenAccordions(tempData.map(() => ""))
        RefreshDataSystem()
        setValidError2(prev => ({ ...prev, general: '' }))
      }

    } catch (error) {
      // setValidError2(prev => ({ ...prev, general: 'An error occurred while adding the entry' }))
    }
  }

  const handleSaveRoles2 = async () => {

    try {

      setUserSpinnerData(true)

      const user = JSON.parse(isUserLoggedIn() || '{}')
      const userId = user?.userRoles?.[0]?.userId

      const transformedData = displayData?.flatMap(item => item?.details?.filter(detail => detail?.existingRemove)?.map(detail => ({
        UserRoleId: detail.roleId,
        SourceSystemId: item.sourceSystemId,
        CreatedBy: userId,
        LastModifiedBy: userId,
        Agent: {
          agentId: detail.agentId,
          agentName: detail.name,
          GPClientDepartmentId: detail.classId
        }
      }))
      ) ?? []

      const responseData = await dispatch(SaveUserRoles({ data: transformedData, userId: selectedRow?.id })).finally(() => setUserSpinnerData(false))

      if (responseData.payload.data) {
        fetchApi(selectedRow)
      }
    } catch (error) {
    }
  }

  // Helper to check if there are roles to save
  const hasRolesToSave2 = displayData?.flatMap(item => item?.details?.filter(entry => entry?.existingRemove))?.length > 0

  return (
    <div>
      <Row>
        <Sidebar
          size="sm"
          open={show}
          title={`Add User Details`}
          headerClassName="mb-1"
          contentClassName="pt-0"
          toggleSidebar={toggleSidebar}

        >
          {(show) ? (
            <Form onSubmit={handleSubmit(onSubmit)}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  e.preventDefault()
                }
              }}
              style={{ margin: '0 0' }}>
              <ModalBody style={{ paddingLeft: '10px', paddingRight: '10px', paddingTop: '20px' }}>
                <Row>
                  <Col sm='12' md='12' lg='12' xl='12'>
                    <div className='mt-2 input-wrapper'>
                      <Controller
                        defaultValue=''
                        control={control}
                        id='newEmail'
                        name='newEmail'
                        render={({ field: { onChange, onBlur } }) => <Input
                          placeholder=''
                          invalid={errors.newEmail && true}
                          value={newEmail}
                          onChange={(val) => {
                            setDisableSpinner(false)
                            const emailValue = val.target.value

                            if (emailValue === "") {
                              setValue("newFirstName", "")
                              setNewFirstName("")
                              setValue("newLastName", "")
                              setNewLastName("")
                              setDisabling(false)
                              setIsEmailProcessed(false)
                            } else {
                              if (isEmailProcessed) {
                                fetchCall()
                              }
                            }

                            setDisableSpinner(false)
                            setNewEmail(emailValue)
                            onChange(val)
                          }}
                          onBlur={async () => {
                            if (!isEmailProcessed) {
                              setTimeout(() => {
                                fetchCall()
                              }, 100)
                            }
                          }}
                        // onKeyDown={(event) => {
                        //     if (event.key === "enter") {
                        //         setTimeout(() => {
                        //             fetchCall()
                        //         }, 100)
                        //     }
                        // }}
                        />}
                      />
                      <Label className='form-label' for={`newEmail`}>
                        New Email
                      </Label>
                      {errors.newEmail && <FormFeedback>{errors.newEmail.message}</FormFeedback>}
                    </div>
                  </Col>
                </Row>
                {!disableSpinner ? <>
                  {disabling ? <>
                    <Row>
                      <Col sm='12' md='12' lg='12' xl='12'>
                        <div className='mt-2 input-wrapper'>
                          <Controller
                            defaultValue=''
                            control={control}
                            id='newFirstName'
                            name='newFirstName'
                            render={({ field: { onChange } }) => <Input
                              placeholder=''
                              invalid={errors.newFirstName && true}
                              value={newFirstName}
                              disabled={true}
                              onChange={(val) => {
                                onChange(val, setNewFirstName(val.target.value))
                              }}
                            />}
                          />
                          <Label className='form-label' for={`newFirstName`}>
                            First Name
                          </Label>
                          {errors.newFirstName && <FormFeedback>{errors.newFirstName.message}</FormFeedback>}
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Col sm='12' md='12' lg='12' xl='12'>
                        <div className='mt-2 input-wrapper'>
                          <Controller
                            defaultValue=''
                            control={control}
                            id='newLastName'
                            name='newLastName'
                            render={({ field: { onChange } }) => <Input
                              placeholder=''
                              invalid={errors.newLastName && true}
                              value={newLastName}
                              disabled={true}
                              onChange={(val) => {
                                onChange(val, setNewLastName(val.target.value))
                              }}
                            />}
                          />
                          <Label className='form-label' for={`newLastName`}>
                            Last Name
                          </Label>
                          {errors.newLastName && <FormFeedback>{errors.newLastName.message}</FormFeedback>}
                        </div>
                      </Col>
                    </Row>
                  </> : <></>}
                </> : <>
                  <ComponentSpinner />
                </>}
              </ModalBody>
              <ModalFooter className='p-0 d-block' style={{ border: 0, marginTop: '30px' }}>
                <Row>
                  <Col sm='12' md='12' lg='12' xl='12' className='p-0 mt-1'>
                    <div className='model_popup_panel model_popup_submit_btn model_popup_footer_fixed' style={{ justifyContent: 'center', padding: "12px 0px", display: "flex", background: "unset" }}>
                      {spinnerStatus ? (
                        <Button.Ripple color='primary' disabled={spinnerStatus} style={{ paddding: "0px 0px" }}>
                          <Spinner size='sm' />
                          <span className='mx-50'>Loading...</span>
                        </Button.Ripple>
                      ) : (
                        <Fragment>
                          <Button className='me-1 reset_button_view' outline color='secondary' style={{ paddding: "0px 0px" }} onClick={() => handleReset()}>
                            <RefreshCcw size={14} className='align-middle me-sm-25 me-0' />
                            <span className='align-middle d-sm-inline-block mx-50'>Reset</span>
                          </Button>
                          <Button className='create_submit_btn' type='submit' style={{ paddding: "0px 0px" }}>
                            {/* <Check size={18} className='align-middle me-sm-25 me-0'></Check> */}
                            <span className='align-middle d-sm-inline-block mx-50'>{'Invite User'}</span>
                          </Button>
                        </Fragment>
                      )}
                    </div>
                  </Col>
                </Row>
              </ModalFooter>
            </Form>
          ) : (
            <ComponentSpinner />
          )}
        </Sidebar>
      </Row>
      <Row>
        <Col lg='6' md='12' sm="12" lx="12" className='my-1'>
          <Row>
            <Col lg='12' md='12'>
              <h5 style={{ fontSize: '18px', color: '#000000' }}>Users and Permissions</h5>
              <p style={{ fontSize: '14px' }}>Manage who has access to the application and grant permissions</p>
            </Col>
            <Col xl='12' lg='12' xs={{ order: 1 }} md={{ order: 0, size: 15 }}>
              <Nav className='mb-1 user_perm_tabs'>
                <NavItem>
                  <NavLink active={active === '1'} onClick={() => toggleTab('1')} className={active === '1' ? 'user_perm_active' : 'user_perm_not_active'}>
                    <span className='fw-bold'>Users</span>
                  </NavLink>
                </NavItem>
              </Nav>
              <TabContent activeTab={active}>
                <TabPane tabId='1'>
                  {!usersSpinner ? (
                    <Fragment>
                      <div className='user-box'>
                        <div style={{ marginTop: '-20px' }}>
                          <Label className='form-label input_label_entity' for='search'> Search users by name or email </Label>
                          <Input
                            id='search'
                            type="text"
                            placeholder="Search..."
                            value={searchText}
                            autoComplete='off'
                            onChange={handleSearchChange}
                          />
                        </div>
                      </div>

                      <div className='user-box table-responsive-wrapper' style={{ maxHeight: "500px", overflowY: "scroll" }}>
                        <Table className="mt-1 user-permission-table " style={{ width: "100%", tableLayout: "fixed" }}>
                          <thead className="thead-dark sticky-header">
                            <tr>
                              <th style={{ width: "30%" }}>Email</th>
                              <th style={{ width: "30%" }}>Name</th>
                              <th style={{ width: "30%" }}>Status</th>
                              <th style={{ width: "10%" }} />
                            </tr>
                          </thead>
                          {filteredData.length > 0 &&
                            <tbody>
                              {filteredData.map((e, index) => {
                                return (
                                  <tr key={e.id} onClick={() => handleRowClick(e)} className={selectedRow?.id === e.id ? 'user_back_show' : 'user_back_not_show'} ref={index === 0 && selectedRow?.id ? tableRef : null}>
                                    <td className={selectedRow?.id === e.id ? 'user_email_show' : 'user_email_not_show'}>{e.email}</td>
                                    <td>{e.firstName}{e.lastName}</td>
                                    <td>{e.status === 1 ? 'Active' : 'inActive'}</td>
                                    <td><ChevronRight size={20} className={selectedRow?.id === e.id ? 'float-right user_perm_icon' : 'float-right user_perm_not_icon'} /></td>
                                  </tr>
                                )
                              })}
                            </tbody>
                          }
                          {filteredData.length === 0 &&
                            <tfoot>
                              <tr>
                                <td style={{ fontSize: "14px", textAlign: "center" }} colSpan={3} className='py-1'><div className='text-center'>No Records to Display</div></td>
                              </tr>
                            </tfoot>
                          }
                        </Table>
                      </div>
                    </Fragment>
                  ) : (
                    <ComponentSpinner />
                  )}
                </TabPane>
                <TabPane tabId='2'>
                  2
                </TabPane>
              </TabContent>
            </Col>
          </Row>
        </Col>
        <Col lg='6' md='12' sm="12" lx="12" className='my-1'>
          <Row>
            {selectedRow && <Col lg='9' md='12' sm='12' xl='8' style={{ minHeight: '60px' }} className='mediaQTab'>
              <h5 style={{ fontSize: '18px', color: '#00ADC3' }}>
                {selectedRow?.firstName} {selectedRow?.lastName}
              </h5>
              <p style={{ fontSize: '14px' }}><span style={{ color: '#00ADC3' }}>
                {selectedRow?.status === 1 ? 'Active' : 'Inactive'}
              </span> - <span>
                  {selectedRow?.email}
                </span></p>
            </Col>}

            <Col xl='4' lg='3' md='6' sm='12' className=' filter-padding d-none'>
              <div className='mb-1' >
                <div style={{ display: "flex", justifyContent: "start" }}>
                  <Button.Ripple color='primary' onClick={handleInviteUserClick} className='inviteUser'>
                    <Plus size={14} className='' style={{ marginTop: '-7px' }} />
                    <span className='align-middles mx-50'>Invite  User</span>
                  </Button.Ripple>
                </div>
              </div>
            </Col>

            <Col xl='12' lg='12' xs={{ order: 0 }} md={{ order: 1, size: 16 }} className="d-none">
              <Nav className='mb-1 user_perm_tab'>
                <NavItem>
                  <NavLink active={activeR === '1'} onClick={() => toggleTabRight('1')} className={activeR === '1' ? 'user_perm_active' : 'user_perm_not_active'}>
                    <span className='fw-bold'>App Permissions</span>
                  </NavLink>
                </NavItem>
              </Nav>
              <TabContent activeTab={activeR}>
                <TabPane tabId='1'>
                  {(roleLoader) ? (
                    <Fragment>
                      <Row>
                        <Col xl='12' lg='12'>
                          <div className='user-box'>
                            <Row>
                              <Col xl='8' lg='8' className="d-none">
                                <div style={{ marginTop: '-20px' }}>
                                  <Label className='form-label input_label_entity' for='search'> Search by type </Label>
                                  <Input
                                    id='search'
                                    type="text"
                                    placeholder=''
                                    value={searchCatg}
                                    autoComplete='off'
                                    onBlur={handleCatgBlur}
                                    onKeyUp={handleCatgBlur}
                                    onChange={(e) => {
                                      setSearchCatg(e.target.value)
                                      setEnterCatgKey('')
                                      if (e.target.value === '') {
                                        setCatgList(menuData)
                                      }
                                    }}
                                    onKeyDown={handleKeyCatgDown}
                                  />
                                </div>
                              </Col>
                              <Col xl='4' lg='4' className="d-none">
                                <Button color='primary' className='btn-next mt-50  float-right' onClick={() => {

                                  saveUserRoles()
                                  setSaveEnabled(false)
                                }}
                                  // disabled={(!isSaveEnabled) && roleDisabled || !accessDisabled || roleData.filter(obj => obj.roleId !== 0).length === 0}
                                  disabled={!isSaveEnabled}
                                >
                                  <span className='align-middle d-sm-inline-block d-none'>Save Roles</span>
                                </Button>
                              </Col>

                            </Row>
                          </div>
                          <div>

                            {/*i need companyList if he is empwr or customerWriter   */}
                            {/* <Select>
                            
                            </Select>    */}

                            {/* neeed add only selective soureS */}

                          </div>
                          <div className='user-box'>
                            <Table className={`user-wotype-table`} responsive>
                              <thead className="thead-dark">
                                <tr>
                                  <th style={{ width: '40%' }}>Type Name</th>
                                  <th style={{ width: '60%' }}>Permission</th>
                                </tr>
                              </thead>
                              {catgList.length > 0 &&
                                < tbody >
                                  {
                                    catgList.map(w => {
                                      const rolesData = [...roleData]
                                      let disableRole = false

                                      if (rolesData) {
                                        if (rolesData.find(find => find.roleId === 1)) {
                                          disableRole = true
                                        }
                                      }

                                      let optionData = []
                                      let findRole = null

                                      if (w.value === 'User') {
                                        optionData = statusData.filter((obj) => [2, 3].includes(obj.value))
                                        if (rolesData.find(find => find.roleId === 2)) {
                                          findRole = statusData.find(find => find.value === 2)
                                        }
                                        if (rolesData.find(find => find.roleId === 3)) {
                                          findRole = statusData.find(find => find.value === 3)
                                        }
                                      }
                                      if (w.value === 'Company Mapping') {
                                        optionData = statusData.filter((obj) => [4, 5].includes(obj.value))
                                        if (rolesData.find(find => find.roleId === 0)) {
                                          findRole = statusData.find(find => find.value === 0)
                                        }
                                        if (rolesData.find(find => find.roleId === 4)) {
                                          findRole = statusData.find(find => find.value === 4)
                                        }
                                        if (rolesData.find(find => find.roleId === 5)) {
                                          findRole = statusData.find(find => find.value === 5)
                                        }
                                      }
                                      if (w.value === 'Vessel Mapping') {
                                        optionData = statusData.filter((obj) => [6, 7].includes(obj.value))
                                        if (rolesData.find(find => find.roleId === 0)) {
                                          findRole = statusData.find(find => find.value === 0)
                                        }
                                        if (rolesData.find(find => find.roleId === 6)) {
                                          findRole = statusData.find(find => find.value === 6)
                                        }
                                        if (rolesData.find(find => find.roleId === 7)) {
                                          findRole = statusData.find(find => find.value === 7)
                                        }
                                      }

                                      return (
                                        <tr key={`w${w.value}`}>
                                          <td className='user_wotype_show'>{w.label}</td>
                                          <td>
                                            <div className='user-type-select'>
                                              <Select
                                                theme={selectThemeColors}
                                                className='react-select'
                                                classNamePrefix='select'
                                                defaultValue={findRole}
                                                value={findRole}
                                                name='clear'
                                                options={optionData}
                                                menuPosition="fixed"
                                                menuPlacement="auto"
                                                isClearable

                                                onChange={(val) => {
                                                  let idsToCheck = []
                                                  if (w.value === 'User') {
                                                    idsToCheck = [2, 3]
                                                  }
                                                  if (w.value === 'Company Mapping') {
                                                    idsToCheck = [4, 5]
                                                  }
                                                  if (w.value === 'Vessel Mapping') {
                                                    idsToCheck = [6, 7]
                                                  }

                                                  const rolesData = [...roleData]

                                                  if (val) {
                                                    const findIndex = rolesData.findIndex((item) => idsToCheck.includes(item.roleId))
                                                    if (findIndex >= 0) {
                                                      const updatedRole = { ...rolesData[findIndex], roleId: val.value }
                                                      rolesData[findIndex] = updatedRole
                                                    } else {
                                                      rolesData.push({ roleId: val.value, userId: selectedRow.id })
                                                    }
                                                  } else {
                                                    const findIndex = rolesData.findIndex((item) => idsToCheck.includes(item.roleId))
                                                    if (findIndex >= 0) {
                                                      rolesData.splice(findIndex, 1)
                                                    }
                                                  }

                                                  setRoleData(rolesData)
                                                  setSaveEnabled(true)

                                                }}

                                                isDisabled={roleDisabled || disableRole}
                                              />
                                            </div>
                                          </td>
                                        </tr>
                                      )
                                    })
                                  }
                                </tbody>
                              }
                              {catgList.length === 0 &&
                                <tfoot>
                                  <tr>
                                    <td style={{ fontSize: "14px", textAlign: "center" }} colSpan={3} className='py-1'>No Records to Display</td>
                                  </tr>
                                </tfoot>
                              }
                            </Table>
                          </div>
                        </Col>
                      </Row>
                    </Fragment>
                  ) : (
                    <ComponentSpinner />
                  )}
                </TabPane>
              </TabContent>
            </Col>
            {selectedRow && (!domain(selectedRow?.email)) && JSON.parse(isUserLoggedIn()).userRoles[0].roleId === 1 && (selectedRow?.id !== JSON.parse(isUserLoggedIn()).userRoles[0]?.userId) && <Col xl='12' lg='12'>
              <Row>
                {/* Agent Selection */}
                <Col xl="6" lg="6" sm="6" md="6">
                  <div className='mt-1'>
                    <Select
                      isClearable
                      onChange={(val) => {
                        setAgentObj(val)
                        setValidError2(prev => ({ ...prev, agentObj: '' }))
                        if (val && val?.value !== agentObj?.value) {
                          setSelectedSourceSystem(null)
                          setSaveRole(null)
                        }
                      }}
                      inputValue={agentInput}
                      classNamePrefix="select"
                      options={companyData}
                      value={agentObj?.label ? agentObj : null}
                      components={{ NoOptionsMessage, ValueContainer: CustomValueContainer }}
                      styles={selectStyles}
                      className={classnames('react-select', {
                        'is-invalid': validError2.agentObj
                      })}
                      onInputChange={setAgentInput}
                      isLoading={isLoading}
                      loadingMessage={() => 'Loading...'}
                      placeholder="Select Agent Id or Name"
                    />
                    {validError2.agentObj && (
                      <div className="invalid-feedback d-block">
                        {validError2.agentObj}
                      </div>
                    )}
                  </div>
                </Col>

                {/* Source System Selection */}
                <Col xl='6' lg='6' className="mt-1">
                  <Select
                    classNamePrefix="select"
                    options={selectSelectOptions}
                    value={selectedSourceSystem ?? null}
                    onChange={(val) => {
                      setSelectedSourceSystem(val)
                      setValidError2(prev => ({ ...prev, selectedSourceSystem: '' }))
                    }}
                    className={classnames('react-select', {
                      'is-invalid': validError2.selectedSourceSystem
                    })}
                    placeholder="Select SourceSystem"
                    styles={selectStyles}
                    components={{ ValueContainer: CustomValueContainer }}
                  />
                  {validError2.selectedSourceSystem && (
                    <div className="invalid-feedback d-block">
                      {validError2.selectedSourceSystem}
                    </div>
                  )}
                </Col>

                {/* Role Selection */}
                <Col xl='6' lg='6' className="mt-1">
                  <Select
                    theme={selectThemeColors}
                    className={classnames('react-select', {
                      'is-invalid': validError2.saveRole
                    })}
                    classNamePrefix='select'
                    options={accessingData(3)}
                    onChange={(val) => {
                      setSaveRole(val)
                      setValidError2(prev => ({ ...prev, saveRole: '' }))
                    }}
                    value={saveRole}
                    menuPosition="fixed"
                    menuPlacement="auto"
                  // isClearable
                  />
                  {validError2.saveRole && (
                    <div className="invalid-feedback d-block">
                      {validError2.saveRole}
                    </div>
                  )}
                </Col>

                {/* Action Buttons */}
                <Col xl='6' lg='6' className='mt-1'>
                  <Button
                    color='primary'
                    className='btn-next mt-50'
                    onClick={handleAddEntry2}
                  //disabled={!selectedSourceSystem || !agentObj || !saveRole}
                  >
                    + Add Entry
                  </Button>

                  {hasRolesToSave2 && (
                    <>
                      {userSpinnerData ? (
                        <Button.Ripple
                          color="primary"
                          disabled={userSpinnerData}
                          className="btn-next mt-50 ml-2"
                          style={{ padding: "0.5rem 1rem" }}
                        >
                          <Spinner size="sm" />
                          <span className="mx-50">Loading...</span>
                        </Button.Ripple>
                      ) : (
                        <Button
                          color="primary"
                          className="btn-next mt-50 ml-2"
                          onClick={handleSaveRoles2}
                        // disabled={!hasRolesToSave || !selectedSourceSystem || !agentObj || !saveRole}
                        >
                          Save Roles
                        </Button>
                      )}
                    </>
                  )}
                  {validError2.general && (
                    <div className="text-danger mt-1">
                      {validError2.general}
                    </div>
                  )}
                </Col>
              </Row>
            </Col>}

            {selectedRow && !JSON.parse(isUserLoggedIn()).isEmployee && (selectedRow?.id !== JSON.parse(isUserLoggedIn()).userRoles[0]?.userId) && <Col xl='12' lg='12'>
              <Row>
                {/* Source System Dropdown */}
                <Col xl="6" lg="6">
                  <Select
                    classNamePrefix="select"
                    options={selectSelectOptions}
                    value={selectedSourceSystem}
                    onChange={(val) => {
                      setSelectedSourceSystem(val)
                      setSelectedCompany([])
                      setValidErrors(prev => ({ ...prev, selectedSourceSystem: "" }))
                    }}
                    className={classnames('react-select', {
                      'is-invalid': validErrors.selectedSourceSystem
                    })}
                    placeholder="Select Source System"
                    styles={selectStyles}
                    components={{ ValueContainer: CustomValueContainer }}
                  />
                  {validErrors.selectedSourceSystem && (
                    <div className="invalid-feedback d-block">
                      {validErrors.selectedSourceSystem}
                    </div>
                  )}
                </Col>

                {/* Company MultiSelect */}
                <Col xl="6" lg="6">
                  {/* <Select
                    isMulti
                    options={selectedSourceSystem?.details || []}
                    value={selectedCompany}
                    onChange={(selectedOptions) => {
                      setSelectedCompany(selectedOptions || [])
                      setValidErrors(prev => ({ ...prev, selectedCompany: "" }))
                    }}
                    className={classnames('react-select', {
                      'is-invalid': validErrors.selectedCompany
                    })}
                    placeholder="Select Companies"
                    components={{ ValueContainer: CustomValueContainer1 }}
                  /> */}
                  <MultiSelect
                    options={selectedSourceSystem?.details ?? []}
                    value={selectedCompany}
                    onChange={(selectedOptions) => {
                      setSelectedCompany(selectedOptions)
                      setValidErrors(prev => ({ ...prev, selectedCompany: "" }))
                    }}
                    // menuPortalTarget={document.body}
                    isSelectAll={true}
                    isClearable
                    isMulti
                    // isDisabled={title === "Deactivate Discount"}
                    placeholder={`Select Companies <span class='text-danger'>*</span>`}
                    components={{ ValueContainer: CustomValueContainer1 }}
                  // menuShouldScrollIntoView={true}
                  />
                  {validErrors.selectedCompany && (
                    <div className="invalid-feedback d-block">
                      {validErrors.selectedCompany}
                    </div>
                  )}
                </Col>

                {/* Role Selection */}
                <Col xl="6" lg="6" className="mt-1">
                  <Select
                    theme={selectThemeColors}
                    className={classnames('react-select', {
                      'is-invalid': validErrors.saveRole
                    })}
                    classNamePrefix="select"
                    options={accessingData(3)}
                    value={saveRole}
                    onChange={(val) => {
                      setSaveRole(val)
                      setValidErrors(prev => ({ ...prev, saveRole: "" }))
                    }}
                    menuPosition="fixed"
                    menuPlacement="auto"
                    isClearable
                  />
                  {validErrors.saveRole && (
                    <div className="invalid-feedback d-block">
                      {validErrors.saveRole}
                    </div>
                  )}
                </Col>

                {/* Action Buttons */}
                <Col xl="6" lg="6" className="mt-1">
                  <Button
                    color="primary"
                    className="btn-next mt-50"
                    onClick={handleAddEntry}
                  // disabled={!selectedSourceSystem || !selectedCompany.length || !saveRole}
                  >
                    + Add Entry
                  </Button>

                  {hasRolesToSave &&
                    <>
                      {userSpinnerData ? (
                        <Button.Ripple
                          color="primary"
                          disabled={userSpinnerData}
                          className="btn-next mt-50 ml-2"
                          style={{ padding: "0.5rem 1rem" }}
                        >
                          <Spinner size="sm" />
                          <span className="mx-50">Loading...</span>
                        </Button.Ripple>
                      ) : (
                        <Button
                          color="primary"
                          className="btn-next mt-50 ml-2"
                          onClick={handleSaveRoles}
                        // disabled={!hasRolesToSave || !selectedSourceSystem || !agentObj || !saveRole}
                        >
                          Save Roles
                        </Button>
                      )}
                    </>}
                </Col>
              </Row>
            </Col>}

            {!userSpinnerData ? (selectedRow && (!domain(selectedRow?.email)) && (selectedRow?.id !== JSON.parse(isUserLoggedIn()).userRoles[0]?.userId) && <Row>
              {
                displayData.length ? displayData.map((item, index) => {

                  return (
                    <div className='mt-1' key={`${index}_container`}>
                      <Accordion
                        key={`${index}_a`}
                        className='accordion-border accordian_design accordion card_style'
                        style={{ border: openAccordions[index]?.length && "solid 1px #00adc3", transition: "0 1s" }}
                        open={openAccordions[index]}
                        toggle={() => toggleAccordion(index)}
                      >
                        <AccordionItem open={openAccordions[index]}>
                          <AccordionHeader targetId={index.toString()}>
                            <div style={{ width: '100%', marginTop: "3px" }}>
                              <span style={{ color: '#313131' }}></span>&nbsp; &nbsp; <span className='cyan_color'>{
                                SourceSystem(item.sourceSystemId)?.label || "not Listed"}</span>
                            </div>
                          </AccordionHeader>
                          <AccordionBody accordionId={index.toString()} show={openAccordions[index]}>
                            <table className="table">
                              <thead>
                                <tr>
                                  <th>Agent ID</th>
                                  <th>Agent Name</th>
                                  <th>Role ID</th>
                                  <th>Remove</th>
                                </tr>
                              </thead>
                              <tbody>
                                {item.details.map((detail, idx) => (
                                  <tr key={idx}>
                                    <td>{detail.agentId}</td>
                                    <td>{detail.agentName}</td>
                                    <td>{roles.find((entry) => entry.id === detail.roleId)?.label || '-'}</td>
                                    <td >
                                      <span onClick={() => handleRemove(index, idx)}>

                                        {detail?.existingRemove ? <Trash color="red" size={16} style={detail?.existingRemove ? { cursor: "pointer" } : {}} /> : "-"}

                                      </span>
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </AccordionBody>
                        </AccordionItem>
                      </Accordion>
                    </div>
                  )
                }) : <div style={{ fontSize: "14px", textAlign: "center", marginTop: "50px" }}><div className='text-center'>No Records to Display</div>
                </div>
              }

            </Row>) : (<ComponentSpinner></ComponentSpinner>)}
          </Row>
        </Col>
      </Row >
    </div >
  )
}
export default RoleManagement
